<template>
  <div class="home">
    <!-- 头部导航 -->
    <header class="header">
      <div class="header-content">
        <div class="logo">
          <img src="@/assets/logo.png" alt="ihongen" />
          <span class="logo-text">洪恩智能编程</span>
        </div>
        <div class="header-right">
          &nbsp;
        </div>
      </div>
    </header>

    <!-- 主横幅区域 -->
    <section class="hero-banner">
      <div class="banner-content">
        <h1 class="hero-title">广东洪恩文化创意科技有限公司</h1>
        <p><span>地址：</span>广东省中山市石岐区青溪路 140号、142号、146-148号及 159-169号（五层之二）</p>
        <p><span>电话：</span>0760-86998958</p>
      </div>
      <div class="banner-image">
        <div class="placeholder-image">
          <img src="@/assets/aicoding_ss.png" alt="洪恩智能编程" />
        </div>
      </div>
    </section>

    <!-- 底部信息 -->
    <footer class="footer">
      <div class="footer-content">
        <div class="footer-links">
          <a href="/zhizhao.jpg" target="_blank" class="footer-link">营业执照</a>
          <a href="/zhangcheng.html" target="_blank" class="footer-link">机构章程</a>
          <a href="/sf.html" target="_blank" class="footer-link">收费标准</a>
          <a href="/stf.html" target="_blank" class="footer-link">收退费规则</a>
          <a href="/hegui2.html" target="_blank" class="footer-link">从业人员合规承诺书</a>
          <a href="/zs.html" target="_blank" class="footer-link">招生简章</a>
          <a href="/template.html" target="_blank" class="footer-link">培训合同示范模板</a>
          <a href="/hegui1.html" target="_blank" class="footer-link">培训材料合规承诺书</a>
          <a href="/privacy1.html" target="_blank" class="footer-link">儿童隐私保护声明</a>
          <a href="/privacy2.html" target="_blank" class="footer-link">平台隐私政策</a>
          <a href="#" class="footer-link">联系我们</a>
        </div>
        <div class="footer-info">
          <p>Copyright ©2026 广东洪恩文化创意科技有限公司</p>
          <p>
            <a href="https://beian.miit.gov.cn" class="footer-link" target="_blank">粤ICP备2025458115号-1</a>
          </p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'ContactView',
};
</script>

<style scoped lang="scss">
.home {
  min-height: 100vh;
  background-color: #ffffff;
}

/* 头部导航 */
.header {
  background-color: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  position: sticky;
  top: 0;
  z-index: 100;
}

.header-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 64px;
}

.logo {
  display: flex;
  align-items: center;
  gap: 12px;

  img {
    height: 40px;
    width: 40px;
  }

  .logo-text {
    font-size: 20px;
    font-weight: 600;
    color: #1a1a1a;
  }
}

.header-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

.header-link {
  text-decoration: none;
  color: #666;
  font-size: 14px;
  padding: 6px 16px;
  border-radius: 4px;
  transition: all 0.3s;

  &:hover {
    color: #5B4FFF;
  }

  &-primary {
    background-color: #5B4FFF;
    color: #fff;

    &:hover {
      background-color: #4840CC;
      color: #fff;
    }
  }
}

.user-dropdown {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  color: #333;
  font-size: 14px;
}

.user-name {
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.nav {
  display: flex;
  gap: 32px;

  .nav-item {
    text-decoration: none;
    color: #666;
    font-size: 16px;
    transition: color 0.3s;

    &:hover {
      color: #5B4FFF;
    }

    &.active {
      color: #5B4FFF;
      font-weight: 600;
    }

    &.download-btn {
      background: linear-gradient(135deg, #5B4FFF 0%, #8B7FFF 100%);
      color: white;
      padding: 8px 20px;
      border-radius: 20px;

      &:hover {
        color: white;
        opacity: 0.9;
      }
    }
  }
}

/* 主横幅 */
.hero-banner {
  max-width: 1200px;
  margin: 0 auto;
  padding: 80px 24px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: center;
}

.banner-content {
  .hero-title {
    font-size: 24px;
    font-weight: 700;
    color: #1a1a1a;
    line-height: 1.3;
    margin-bottom: 40px;
  }

  >p {
    font-size: 16px;
    color: #666;
    margin-bottom: 20px;

    span {
      font-weight: 600;
    }
  }
}

.hero-buttons {
  display: flex;
  gap: 16px;

  .btn {
    padding: 14px 32px;
    font-size: 16px;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s;
    font-weight: 500;

    &.btn-primary {
      background: linear-gradient(135deg, #5B4FFF 0%, #8B7FFF 100%);
      color: white;

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 8px 20px rgba(91, 79, 255, 0.3);
      }
    }

    &.btn-secondary {
      background: white;
      color: #5B4FFF;
      border: 2px solid #5B4FFF;

      &:hover {
        background: #f5f4ff;
      }
    }
  }
}

.banner-image {
  .placeholder-image {
    width: 546px;
    height: 327px;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);

    img {
      width: 100%;
      height: auto;
    }
  }
}

/* 底部 */
.footer {
  background: #1a1a1a;
  color: #999;
  padding: 40px 24px 24px;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
}

.footer-links {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  margin-bottom: 24px;
  justify-content: center;

  .footer-link {
    color: #999;
    text-decoration: none;
    font-size: 14px;

    &:hover {
      color: #fff;
    }
  }
}

.footer-info {
  text-align: center;
  padding-top: 24px;
  border-top: 1px solid #333;

  p {
    margin: 8px 0;
    font-size: 14px;
  }

  .footer-link {
    color: #999;
    text-decoration: none;
    margin: 0 12px;

    &:hover {
      color: #fff;
    }
  }
}

/* 响应式设计 */
@media (max-width: 1024px) {
  .courses-grid,
  .advantages-grid,
  .works-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .teachers-grid {
    grid-template-columns: repeat(3, 1fr);
  }

  .hero-banner {
    grid-template-columns: 1fr;
    gap: 40px;
  }
}

@media (max-width: 768px) {
  .nav {
    display: none;
  }

  .hero-banner {
    padding: 40px 24px;
    gap: 24px;
  }

  .banner-content {
    .hero-title {
      font-size: 28px !important;
      margin-bottom: 16px;
    }

    .hero-subtitle {
      font-size: 16px !important;
      margin-bottom: 24px;
    }
  }

  .banner-image {
    .placeholder-image {
      width: 100%;
      height: auto;
      max-height: 300px;

      img {
        width: 100%;
        height: auto;
      }
    }
  }

  .hero-buttons {
    flex-direction: column;

    .btn {
      width: 100%;
    }
  }

  .courses-grid,
  .advantages-grid,
  .works-grid,
  .teachers-grid {
    grid-template-columns: 1fr;
  }

  .section-title {
    font-size: 28px !important;
  }
}
</style>
